import { ColumnDirective, ColumnsDirective, ExcelFilter, Filter, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";
import { statusObject } from "../../utils/allProductStatus";
import { cashnator } from "../../utils/functions";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType } from "../../utils/gradingTypes";

const PartnerProductsList = ({ products }) => {

    const handleQueryCellInfo = (args) => {
        if (args.column.field === "gradedAt") {
            if (args.data.gradedAt) {
                args.cell.style.color = "green";
            } else {
                args.cell.style.color = "red";
            }
        }
    };

    const filterSettings = { type: 'Excel' };

    return (
        <GridComponent dataSource={products} filterSettings={filterSettings} allowFiltering allowSorting allowPaging queryCellInfo={handleQueryCellInfo} pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='user.name' headerText="Nome" width='100' textAlign="Center" />
                <ColumnDirective field='gradingType' headerText="Tipo" width='120' textAlign="Center" valueAccessor={(f, d) => { return getGradingTypeLabel(d?.gradingType) }} />
                <ColumnDirective field='autographEvaluation' headerText="Autógrafo" width='110' textAlign="Center" valueAccessor={(f, d) => { return d?.autographEvaluation ? "Sim" : "Não" }} />
                <ColumnDirective field='preLacreFormat' headerText="Pré lacre" width='150' textAlign="Center" valueAccessor={(f, d) => { return normalizeGradingType(d?.gradingType) === "pre" && d?.preLacreFormat ? getPreLacreFormatLabel(d?.preLacreFormat) : "-" }} />
                <ColumnDirective field='numberOfCards' headerText="Nº de itens" width='100' textAlign="Center" />
                <ColumnDirective field='delivery' width='100' headerText="Entrega" textAlign="Center" />
                <ColumnDirective field='finalPrice' width='100' headerText="Valor final" textAlign="Left" valueAccessor={(f, d) => { return cashnator(d?.finalPrice) }} />
                <ColumnDirective field='createdAt' width='100' headerText="Criado" textAlign="Center" type="date" format="dd/MM/yyyy" />
                <ColumnDirective field='receivedAt' width='100' headerText="Recebido" textAlign="Center" type="date" format="dd/MM/yyyy" />
                <ColumnDirective field='paidAt' width='100' headerText="Pago" textAlign="Center" format="dd/MM/yyyy" type="date" />
                <ColumnDirective field='calculatedDeadline' headerText="Prazo" width='100' textAlign="Center" format="dd/MM/yyyy" type="date" />
                <ColumnDirective field='status' width='100' headerText="Status" textAlign="Center" valueAccessor={(f, d) => { return statusObject[d?.status] }} />
                <ColumnDirective field='gradedAt' width='100' headerText="Em Processo de Lacre" textAlign="Center" valueAccessor={(f, d) => { return d?.gradedAt ? "✔" : "X" }} />
                <ColumnDirective width='70' textAlign="Center" template={(d, f) => { return <a href={`/partner/products/${d?._id}`} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</a> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page, Filter, ExcelFilter]} />
        </GridComponent>
        // <table className="text-center m-auto gap-5">
        //     <thead>
        //         <tr>
        //             <th className="p-4">Nome Cliente</th>
        //             <th className="p-4">Email Cliente</th>
        //             <th className="p-4">Nº Cartas</th>
        //             <th className="p-4">Criado</th>
        //             <th className="p-4">Status</th>
        //             <th className="p-4"></th>
        //         </tr>
        //     </thead>
        //     <tbody>
        //         {
        //             products.map((product, idx) => (
        //                 <tr key={idx}>
        //                     <td className="p-4">{product.user.name}</td>
        //                     <td className="p-4">{product.user.email}</td>
        //                     <td className="p-4">{product.numberOfCards}</td>
        //                     <td className="p-4">{formatarData(product.createdAt)}</td>
        //                     <td className="p-4">{partnerStatusObject[product.status]}</td>
        //                     <td className="p-4"><Button classes="bg-blue-500 hover:bg-blue-800" click={() => handleEdit(product)}>Atualizar</Button></td>
        //                 </tr>

        //             ))
        //         }
        //     </tbody>
        // </table>
    )
}

export default PartnerProductsList;